import { computed } from 'vue';
import { loadScript } from '~/utils/loadScript';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useExperiments from '~/stores/useExperimentsStore';
import { useEnvProps } from '~/composables/useEnvProps';
/* istanbul ignore file */

/**
 * Collects key props from dynamic sources and return them in one single data object.
 */
export default function useOutfittingShopSimilar() {
  const { isMcom, isProduction } = useEnvProps();
  const { experimentFlags } = useExperiments();
  const { killswitches } = useKillswitches();

  const isExperimentEnabled = computed(() => experimentFlags.shopTheLookEnabled && killswitches.shopTheLookEnabled);

  const start = async () => {
    const shopSimilarScriptUrl = 'https://web-assets.stylitics.com/loader/latest/loader.js';
    const accountName = isMcom ? 'macys' : 'bloomingdales';
    const envName = isProduction ? 'production' : 'staging';

    if (!isExperimentEnabled.value) return;

    try {
      await loadScript(shopSimilarScriptUrl);
      const StartFunction = window.StyliticsShopSimilarWidget;

      const widgetInstance = new StartFunction(accountName, {
        api: {
          env: envName,
        },
      });

      widgetInstance.start();
    } catch {
      console.error('Error loading Outfitting Shop Similar script');
    }
  };

  return {
    start,
  };
}
